import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-basic-layout',
  standalone: false,
  templateUrl: './basic-layout.component.html'
})
export class BasicLayoutComponent {

  language = localStorage.getItem('language') || 'ar';
  
  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
  }

  changeLanguage() {
    let lang = this.language == 'en' ? 'ar' : 'en'
    localStorage.setItem('language', lang);
    window.location.reload();
  }
}
